export default "__VITE_ASSET__d349fe6e__"